import React from 'react';
import styled from 'styled-components';

const Header = () => {
  return (
    <HeaderContainer>
    <header className="shadow-md fixed w-full top-0 z-10">
      <nav className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <h1>ViooVIP</h1>
          <div className="hidden md:flex space-x-6">
            {/* <a href="#home">Home</a>
            <a href="#about">About Us</a>
            <a href="#services">Services</a>
            <a href="#contact">Contact Us</a> */}
          </div>
        </div>
      </nav>
    </header>
    </HeaderContainer>
  );
};

const HeaderContainer = styled.header`
  margin-bottom: 4rem;

  h1 {
    font-size: 1.5rem;
    font-weight: bold;
    color: #CCC;
  }

  a {
    color: #CCC;
    text-decoration: none;
    transition: transform 0.2s;

    &:hover {
      transform: translateY(-3px);
    }

    img {
      width: 24px;
      height: 24px;
    }
  }
`;

export default Header; 